import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiTag, FiUsers, FiTrendingUp, FiGlobe } from 'react-icons/fi';

const Directory = () => {
  const sampleFields = [
    { icon: FiTag, label: 'Specialty', value: 'AI Strategy & Automation' },
    { icon: FiUsers, label: 'Market', value: 'Healthcare & Construction' },
    { icon: FiTrendingUp, label: 'Proof of value', value: 'Process optimization, ROI delivery' },
    { icon: FiGlobe, label: 'Partnership signal', value: 'Seeking integration partners' }
  ];

  const sampleTags = ['Strategy', 'Automation', 'Training', 'Leadership'];

  return (
    <section className="py-16 px-6 max-w-5xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="text-center mb-12"
      >
        <h2 className="text-2xl md:text-3xl font-bold text-dc-teal-deep mb-4">
          The AI Business Consultant Directory
        </h2>
        <p className="text-lg text-dc-teal-signal font-medium mb-4">
          A clearer home for your AI work.
        </p>
        <p className="text-dc-text/80 max-w-3xl mx-auto leading-relaxed">
          The Build Your Network Membership includes a listing inside the AI Business Consultant Directory. This forms a profile people can understand, search, and refer. It's a directory listing built around specialty, market, proof of value, and partnership opportunities.
        </p>
      </motion.div>

      {/* Mock directory listing preview */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.1 }}
        className="bg-white rounded-3xl shadow-soft border border-dc-teal-deep/5 overflow-hidden mb-12"
      >
        {/* Domain badge */}
        <div className="bg-dc-teal-deep/5 px-6 py-3 flex items-center justify-between border-b border-dc-teal-deep/10">
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-dc-teal-signal"></div>
            <span className="text-sm font-display text-dc-teal-deep/70 font-medium">aibusinessconsultantdirectory.com</span>
          </div>
          <span className="text-xs text-dc-gold-1 font-medium">AI Builder Profile</span>
        </div>

        {/* Preview content */}
        <div className="p-8">
          <div className="flex flex-wrap gap-2 mb-6">
            {sampleTags.map((tag, idx) => (
              <span key={idx} className="bg-dc-teal-signal/10 text-dc-teal-deep text-xs font-medium px-3 py-1 rounded-full">
                {tag}
              </span>
            ))}
          </div>

          <div className="grid md:grid-cols-2 gap-4">
            {sampleFields.map((field, idx) => (
              <div key={idx} className={`bg-dc-teal-signal/5 rounded-xl p-4 border ${idx % 2 === 0 ? 'border-dc-teal-deep/10' : 'border-dc-gold-1/20'}`}>
                <div className="flex items-center gap-2 mb-2">
                  <SafeIcon icon={field.icon} className={`w-4 h-4 ${idx % 2 === 0 ? 'text-dc-teal-signal' : 'text-dc-gold-1'}`} />
                  <span className="text-xs font-display text-dc-teal-deep/70 uppercase tracking-wider">{field.label}</span>
                </div>
                <p className="text-sm text-dc-text/90">{field.value}</p>
              </div>
            ))}
          </div>

          <div className="mt-6 pt-4 border-t border-dc-teal-deep/10">
            <p className="text-xs text-dc-teal-deep/60 text-center">
              Directory sponsorship and ecosystem visibility powered by RepUpgrade.
            </p>
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default Directory;